import { Text } from '@thefarmersfront/kitchen';

import styles from './DialogMessage.module.scss';

interface DialogMessageProps {
  /** 주요 메시지 */
  mainMessage: React.ReactNode;
  /** 부가 설명 */
  captionMessage: React.ReactNode;
}

/**
 * Dialog 내부에서 주요 메시지와 부가 설명을 함께 표시하는 컴포넌트
 */
const DialogMessage = ({ mainMessage, captionMessage }: DialogMessageProps) => {
  return (
    <>
      <Text size="large" element="p">
        {mainMessage}
      </Text>
      <Text className={styles['caption']} size="medium" color="tertiary" element="p">
        {captionMessage}
      </Text>
    </>
  );
};

export default DialogMessage;
